import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { GrupoDetalharRoutingModule } from "./grupo-detalhar-routing.module";
import { GrupoDetalharComponent } from "./grupo-detalhar.component";

import { ButtonModule } from "primeng/button";
import { ChipModule } from "primeng/chip";
import { EditorModule } from "primeng/editor";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { RippleModule } from "primeng/ripple";
import { DividerModule } from "primeng/divider";
import { FormsModule } from "@angular/forms";
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { TableModule } from "primeng/table";
import { InputMaskModule } from "primeng/inputmask";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";




@NgModule({
    imports: [
        CommonModule,
        GrupoDetalharRoutingModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        DividerModule,
        TableModule,
        InputMaskModule,
        FormatPipeModule,
        ProgressSpinnerModule,
        MessagesModule

    ],
    declarations: [GrupoDetalharComponent]
})
export class GrupoDetalharModule { }
